import { useQuery } from '@tanstack/react-query';

import { businessPlanQueryKeys } from '../businessPlan-qk';
import { BusinessPlanApi } from '../businessPlan.api';

export const useGetAllBusinessPlans = () => {
  return useQuery({
    queryKey: businessPlanQueryKeys.businessPlans(),
    queryFn: () => BusinessPlanApi.getAllBusinessPlans(),

    // TODO fix the metadata parsing issues
    //   select: (businessPlans) => ({
    //     ...businessPlans,
    //     content: businessPlans.content.map(
    //       (businessPlan): IBusinessPlanEntity => ({
    //         ...businessPlan,
    //         metadata: JSON.parse(businessPlan.metadata),
    //       }),
    //     ),
    //   }),
  });
};
